// frontend_react/src/components/common/CompanyAutocomplete.jsx

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { searchCompanies } from "../../services/activityApi";

export default function CompanyAutocomplete({ value, siret, onChange }) {
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    const q = value?.trim();
    const s = siret?.trim();

    if (!q && !s) {
      setResults([]);
      return;
    }

    const timer = setTimeout(async () => {
      setSearching(true);

      try {
        const res = await searchCompanies(s ? { siret: s } : { q });
        setResults(res.data.companies ?? []);
      } catch (err) {
        console.error("Erreur recherche société :", err);
        setResults([]);
      } finally {
        setSearching(false);
      }
    }, 350);

    return () => clearTimeout(timer);
  }, [value, siret]);

  const selectCompany = (company) => {
    onChange({
      company_uuid: company.uuid,
      company_name: company.name || "",
      company_siret: company.siret || "",
    });

    setResults([]);
  };

  return (
    <Wrapper>
      <FieldGroup>
        <label>Société</label>
        <input
          value={value || ""}
          onChange={(e) =>
            onChange({
              company_uuid: null,
              company_name: e.target.value,
              company_siret: siret || "",
            })
          }
          placeholder="Nom de l'entreprise"
        />
      </FieldGroup>

      <FieldGroup>
        <label>SIRET</label>
        <input
          value={siret || ""}
          onChange={(e) =>
            onChange({
              company_uuid: null,
              company_name: value || "",
              company_siret: e.target.value,
            })
          }
          placeholder="SIRET"
        />
      </FieldGroup>

      {searching && <Hint>Recherche société...</Hint>}

      {results.length > 0 && (
        <Results>
          {results.map((company) => (
            <ResultButton
              key={company.uuid}
              type="button"
              onClick={() => selectCompany(company)}
            >
              <strong>{company.name}</strong>
              <span>{company.siret || "SIRET non renseigné"}</span>
              <small>
                {company.postal_code || "—"} {company.city || ""}
              </small>
            </ResultButton>
          ))}
        </Results>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 0.65fr;
  gap: 0.75rem;
  grid-column: 1 / -1;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const FieldGroup = styled.div`
  display: grid;
  gap: 0.35rem;

  label {
    font-size: 0.75rem;
    opacity: 0.72;
    font-weight: 850;
  }

  input {
    width: 100%;
    min-height: 40px;
    border: none;
    border-radius: 10px;
    padding: 0.7rem;
    background: #fff9ea;
    color: #0b1328;
    font-weight: 750;
    box-sizing: border-box;
    outline: none;
  }
`;

const Hint = styled.small`
  grid-column: 1 / -1;
  opacity: 0.7;
`;

const Results = styled.div`
  position: absolute;
  top: calc(100% + 0.35rem);
  left: 0;
  right: 0;
  z-index: 20;
  display: grid;
  gap: 0.35rem;
  padding: 0.5rem;
  border-radius: 14px;
  background: #0b1328;
  border: 1px solid rgba(255, 249, 234, 0.22);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.35);
`;

const ResultButton = styled.button`
  display: grid;
  gap: 0.2rem;
  border: none;
  border-radius: 10px;
  padding: 0.65rem;
  text-align: left;
  background: rgba(255, 255, 255, 0.08);
  color: #f7f7f7;
  cursor: pointer;

  strong {
    color: #fff9ea;
  }

  span,
  small {
    opacity: 0.75;
  }

  &:hover {
    background: rgba(255, 249, 234, 0.14);
  }
`;